import { z } from "zod";

import { m } from "@/paraglide/messages";

export const passwordValidator = z
  .string()
  .regex(
    /^(?=.*[A-Za-z].*[A-Za-z])(?=.*\d.*\d).{12,}$/,
    m.password_invalidation(),
  );
